import { render } from "./rechargeUSDT.vue?vue&type=template&id=ba194e8a&scoped=true"
import script from "./rechargeUSDT.vue?vue&type=script&lang=js"
export * from "./rechargeUSDT.vue?vue&type=script&lang=js"

import "./rechargeUSDT.vue?vue&type=style&index=0&id=ba194e8a&scoped=true&lang=css"
import "./rechargeUSDT.vue?vue&type=style&index=1&id=ba194e8a&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba194e8a"]])

export default __exports__